import { defineMessages } from "react-intl";

export const loyaltyTagCommonMessages = defineMessages({
  ticker: {
    id: "app.ticker",
    defaultMessage: "Ticker",
  },
  save: {
    id: "app.entityForm.submit",
    defaultMessage: "Save",
  },
  edit: {
    id: "app.entityForm.edit",
    defaultMessage: "Edit",
  },
  back: {
    id: "app.entityForm.goBack",
    defaultMessage: "Back",
  },

  // modal
  createErrorTitle: {
    id: "loyaltyTags.createErrorTitle",
    defaultMessage: "Error creating item",
  },
  createErrorDescription: {
    id: "loyaltyTags.createErrorDescription",
    defaultMessage: "An error occurred while creating the item",
  },
  createSuccessTitle: {
    id: "loyaltyTags.createSuccessTitle",
    defaultMessage: "Item created",
  },
  createSuccessDescription: {
    id: "loyaltyTags.createSuccessDescription",
    defaultMessage: "The item has been created successfully",
  },
  updateSuccessTitle: {
    id: "loyaltyTags.updateSuccessTitle",
    defaultMessage: "Item updated",
  },
  updateSuccessDescription: {
    id: "loyaltyTags.updateSuccessDescription",
    defaultMessage: "The item has been updated successfully",
  },
  updateErrorTitle: {
    id: "loyaltyTags.updateErrorTitle",
    defaultMessage: "Error updating item",
  },
  updateErrorDescription: {
    id: "loyaltyTags.updateErrorDescription",
    defaultMessage: "An error occurred while updating the item",
  },
});
